import Page from '../../classes/Page';
import aboutAnimation from './animation';

const aboutPage = new Page({
	onInit: aboutAnimation,
	name: 'about',
	rootElementId: 'js-about-page'
});

export default aboutPage;
